<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<div
  role="radiogroup"
  [formGroup]="group"
  [id]="id"
  [attr.data-name]="model.name"
  [attr.aria-label]="model.legend || model.label || null"
  [ngClass]="[getClass('element', 'control'), getClass('grid', 'control')]"
  [tabindex]="safeTabIndex"
  (change)="onChange($event)"
>
  <p-radio-group [ngClass]="getClass('element', 'option')" [formControlName]="model.id" [name]="model.name">
    @for (option of model.options$ | async; track option; let i = $index) {
      <p-radio-group-option
        [label]="option.label ?? undefined"
        [value]="option.value"
        (blur)="onBlur($event)"
        (focus)="onFocus($event)"
        [id]="model.name + i"
      ></p-radio-group-option>
    }
  </p-radio-group>
</div>
